<template>
	<div v-if="!respondeuCookies">
		<div class="banner-cookies" v-if="!personalizar">
			<a-row type="flex" justify="space-between" align="middle">
				<a-col :span="24">
					<div class="titulo-banner-cookies">
						Utilizamos os Cookies para auxiliar a sua navegação
					</div>
					<div class="banner-cookies-content">
						Utilizamos <b>Cookies</b> para aprimorar sua experiência
						de navegação em nosso <i>Site</i>, <i>Blog</i> e
						<i>Plataformas</i>, personalizar conteúdos e anúncios,
						bem como recomendar soluções que possam ser do seu
						interesse. Ao clicar em "Aceitar todos os cookies", você
						concorda com o uso dos Cookies conforme descrito. Caso
						prefira, você pode optar por recusá-los. Para mais
						informações, acesse nossa Política Cookies, clicando
						<a
							href="https://blog.kuriertecnologia.com.br/wp-content/uploads/2025/04/Politica-de-Cookies-SITE-2025.2.pdf"
							target="_blank"
						>
							aqui</a
						>.
					</div>
				</a-col>
			</a-row>

			<a-row
				type="flex"
				justify="space-around"
				align="start"
				v-if="!personalizar"
				:gutter="20"
			>
				<a-col :span="8">
					<a-button type="link" @click="personalizar = !personalizar">
						personalizar
					</a-button>
				</a-col>

				<a-col :span="8">
					<a-button type="default" block @click="rejeitarTodos()">
						Rejeitar não necessários
					</a-button>
				</a-col>

				<a-col :span="8">
					<a-button type="primary" block @click="permitirTodos()">
						Aceitar todos os cookies
					</a-button>
				</a-col>
			</a-row>
		</div>
		<div class="banner-cookies-personalizar" v-if="personalizar">
			<a-row type="flex" justify="space-between" align="middle">
				<a-col :span="24">
					<a-row type="flex" justify="space-between" align="middle">
						<a-col>
							<div class="titulo-banner-cookies">
								Configuração de Cookies
							</div>
						</a-col>

						<a-col>
							<span
								class="icone-fechar"
								@click="personalizar = !personalizar"
							>
								<a-icon type="close" />
								<!-- <CloseOutlined /> -->
							</span>
						</a-col>
					</a-row>

					<div class="divisor" />

					<div class="banner-cookies-content-personalizar">
						<a-row
							type="flex"
							justify="space-between"
							align="start"
						>
							<a-col :span="12" class="text-left">
								<span class="titulo-cookie">
									Cookies Necessários
								</span>
								<br />
								<span class="descricao-cookie">
									Essenciais para o funcionamento do site.
								</span>
							</a-col>
							<a-col :span="12" class="text-right">
								<span class="sempre-ativo">
									Sempre Ativos
								</span>
							</a-col>
						</a-row>
						<a-row
							type="flex"
							justify="space-between"
							align="start"
						>
							<a-col :span="12" class="text-left">
								<span class="titulo-cookie">
									Cookies de Desempenho
								</span>
								<br />
								<span class="descricao-cookie">
									Ajudam a entender como você utiliza o site.
								</span>
							</a-col>
							<a-col :span="12" class="text-right">
								<a-switch
									v-model:checked="cookiesDesempenho"
									size="small"
								></a-switch>
							</a-col>
						</a-row>
						<a-row
							type="flex"
							justify="space-between"
							align="start"
						>
							<a-col :span="12" class="text-left">
								<span class="titulo-cookie">
									Cookies de Publicidade
								</span>
								<br />
								<span class="descricao-cookie">
									Utilizados para entregar anúncios
									relevantes.
								</span>
							</a-col>
							<a-col :span="12" class="text-right">
								<a-switch
									v-model:checked="cookiesPublicidade"
									size="small"
								></a-switch>
							</a-col>
						</a-row>
					</div>
				</a-col>
			</a-row>

			<a-row type="flex" justify="space-around" align="middle">
				<a-col :span="12">
					<a-row>
						<a-col :span="24">
							<a-button
								class="btn-permitir"
								type="default"
								block
								size="small"
								@click="permitirTodos()"
							>
								Permitir Todos
							</a-button>
						</a-col>

						<a-col :span="24">
							<a-button
								type="primary"
								block
								size="small"
								class="btn-recusar"
								@click="rejeitarTodos()"
							>
								Rejeitar Não Necessários
							</a-button>
						</a-col>
					</a-row>
				</a-col>
				<a-col :span="8" class="text-right">
					<a-button type="link" @click="salvarPersonalizado()">
						Salvar
					</a-button>
				</a-col>
			</a-row>
		</div>
	</div>
</template>

<script>
//import { CloseOutlined } from "@ant-design/icons-vue";

export default {
	name: "BannerCookies",
	components: {
		//CloseOutlined,
	},

	data() {
		return {
			personalizar: false,
			cookiesDesempenho: true,
			cookiesPublicidade: true,
			respondeuCookies: false,
		};
	},

	created() {
		this.consultarRespostasCookies();
	},

	methods: {
		consultarRespostasCookies() {
			const cookies = localStorage.getItem("Cookies");

			if (cookies && cookies.split(",").includes("NECESSARIOS")) {
				this.respondeuCookies = true;
			} else {
				this.respondeuCookies = false;
			}
		},

		permitirTodos() {
			this.respondeuCookies = true;

			this.cookiesDesempenho = true;
			this.cookiesPublicidade = true;

			localStorage.setItem("Cookies", [
				"NECESSARIOS",
				"DESEMPENHO",
				"PUBLICIDADE",
			]);
		},

		rejeitarTodos() {
			this.respondeuCookies = true;

			this.cookiesDesempenho = false;
			this.cookiesPublicidade = false;
			localStorage.setItem("Cookies", ["NECESSARIOS"]);
		},

		salvarPersonalizado() {
			this.respondeuCookies = true;

			let cookies = ["NECESSARIOS"];

			if (this.cookiesDesempenho) {
				cookies.push("DESEMPENHO");
			}

			if (this.cookiesPublicidade) {
				cookies.push("PUBLICIDADE");
			}

			localStorage.setItem("Cookies", cookies);
		},
	},
	mounted() {},
};
</script>

<style scoped lang="less">
.banner-cookies {
	position: fixed;
	bottom: 20px;
	right: 20px;
	padding: 10px;
	text-align: center;
	z-index: 9999;
	width: 700px;
	height: 220px;
	border-radius: 8px;
	padding: 20px 30px;
	gap: 10px;
	background: #fff;
	border: 1px solid #e8e8e8;
	box-shadow: 5px 15px 20px 0px #00000040;
	user-select: none;
}

.banner-cookies-personalizar {
	position: fixed;
	bottom: 20px;
	right: 20px;
	padding: 10px;
	text-align: left;
	z-index: 9999;
	width: 500px;
	height: 395px;
	border-radius: 8px;
	padding: 20px 30px;
	gap: 10px;
	background: #fff;
	border: 1px solid #e8e8e8;
	box-shadow: 5px 15px 20px 0px #00000040;
	user-select: none;
}

.titulo-banner-cookies {
	font-size: 16px;
	font-weight: 600;
	color: #000;
	margin-bottom: 10px;
	text-align: left;
}

.banner-cookies-content {
	color: #000;
	font-weight: 400;
	font-size: 13px;
	line-height: 18px;
	letter-spacing: 0%;
	text-align: left;
	margin-bottom: 30px;
}

.banner-cookies-content-personalizar {
	color: #000;
	font-weight: 400;
	font-size: 13px;
	line-height: 18px;
	letter-spacing: 0%;
	text-align: left;
	margin-bottom: 20px;
}

.text-left {
	text-align: left;
	margin-bottom: 10px;
}

.text-right {
	text-align: right;
}

.divisor {
	height: 1px;
	background-color: #dedede;
	margin: 10px 0;
}

.titulo-cookie {
	font-size: 14px;
	font-weight: 600;
	color: #000;
	margin-bottom: 10px;
}

.descricao-cookie {
	font-size: 13px;
	font-weight: 400;
	color: #000;
	margin-bottom: 10px;
}

.sempre-ativo {
	font-size: 13px;
	font-weight: 600;
	color: #266ef2;
	text-align: right;
}

.btn-recusar {
	margin-top: 10px;
}

.icone-fechar {
	cursor: pointer;
	color: black;
}
</style>
